import { useState } from "react";
import { isPolicyPayoutAnnuity } from "js/utilities";
import { useTranslation } from "react-i18next";
import AgentInfoCard from "components/AgentPortal/PolicyDetails/PolicyCards/AgentInfoCard";
import DeathBenefitCard from "components/AgentPortal/PolicyDetails/AnnuitiesPolicyCards/DeathBenefitCard";
import ContractValues from "components/AgentPortal/PolicyDetails/AnnuitiesPolicyCards/ContractValues";
import OwnerAndInsuredCard from "components/AgentPortal/PolicyDetails/AnnuitiesPolicyCards/OwnerAndInsuredCard";
import CardBase from "components/General/CardBase";
import DepositsAndWithdrawals from "components/General/DepositsAndWithdrawals";
import AgentSendReminderModal from "components/AgentPortal/ModalDialogs/AgentSendReminderModal";
import CoverageAndDocuments from "components/AgentPortal/PolicyDetails/AnnuitiesPolicyCards/CoverageAndDocuments";
import PaymentDetails from "components/AgentPortal/PolicyDetails/AnnuitiesPolicyCards/PaymentDetails";
import BeneficiariesCard from "components/AgentPortal/PolicyDetails/PolicyCards/BeneficiariesCard";

const SinglePolicyAnnuityView = ({
  policy,
  policyDetail,
  filteredDocuments,
  deathBenefitValue,
}) => {
  const { t } = useTranslation();
  const [isOpenSendReminder, setIsOpenSendReminder] = useState(false);
  return (
    <>
      <div className="grid grid-cols-1 gap-4 xl:gap-6">
        <CoverageAndDocuments
          streams={policyDetail?.streams}
          policy={policy}
          filteredDocuments={filteredDocuments}
        />

        {!isPolicyPayoutAnnuity(policyDetail) &&
          policyDetail?.financials?.cashValues?.length > 0 && (
            <ContractValues
              cashValues={policyDetail.financials.cashValues[0]}
              policy={policy}
            />
          )}

        {policyDetail?.streams?.length > 0 && (
          <PaymentDetails paymentStream={policyDetail.streams} />
        )}

        <OwnerAndInsuredCard policy={policy} policyDetail={policyDetail} />
        {isPolicyPayoutAnnuity(policy) ? (
          <BeneficiariesCard policyDetail={policyDetail} />
        ) : (
          <DeathBenefitCard
            data={policyDetail}
            deathBenefit={deathBenefitValue}
          />
        )}

        {policyDetail && !policyDetail?.streams && (
          <DepositsAndWithdrawals
            deposits={policyDetail?.deposits}
            withdrawals={policyDetail?.withdrawals}
          />
        )}
        <AgentInfoCard policy={policy} policyDetail={policyDetail} />
      </div>

      <AgentSendReminderModal
        isOpenSendReminder={isOpenSendReminder}
        setIsOpenSendReminder={setIsOpenSendReminder}
      />
    </>
  );
};

export default SinglePolicyAnnuityView;
